export const formatPrice = (x) =>
  x && `$${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

export const emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const publicImage = (filename) =>
  `${process.env.PUBLIC_URL || ""}/images/${filename}`;

export const resolveMediaUrl = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const base = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
  return `${base}/${String(url).replace(/^\//, "")}`;
};